import { motion } from "framer-motion";
import { Star } from "lucide-react";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] ${
      dark ? "text-brand-warm" : "text-brand-primary"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-brand-warm" : "bg-brand-primary"}`} />
    {children}
  </span>
);

export const Stars = ({ count = 5, className = "" }) => (
  <div className={`flex gap-0.5 ${className}`} aria-label={`${count} star rating`}>
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-brand-warm text-brand-warm" strokeWidth={1.5} />
    ))}
  </div>
);
